export const BID_DETAILS_LOADING = 'BID_DETAILS_LOADING';
export const BID_DETAILS_LOADING_ERROR = 'BID_DETAILS_LOADING_ERROR';
export const BID_DETAILS_DATA = 'BID_DETAILS_DATA';
export const CLEAR_BID_DETAILS_ERROR = 'CLEAR_BID_DETAILS_ERROR';
export const UPDATING_BID_DETAILS = 'UPDATING_BID_DETAILS';
export const BID_DETAIL_SUBMIT = 'BID_DETAIL_SUBMIT';
export const BID_DETAIL_SUBMIT_ERROR = 'BID_DETAIL_SUBMIT_ERROR';
export const SET_BID_DETAIL_PRINT_DATA = 'SET_BID_DETAIL_PRINT_DATA';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateBidDetails/types.js